/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';

class SocialAvatar extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        let avatarClass = 'social-avatar',
            animatedClass = 'animated-avatar',
            animatedWrapperClass = 'animated-avatar-wrapper',
            avatar = null,
            avatarBlock = null,
            defaultIcon = false,
            ServiceIcon = null,
            serviceIcon = null,
            serviceName = '',
            compactName = null;

        if (this.props.social.psID) {
            if (!(ServiceIcon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.social.psID)])) {
    			ServiceIcon = IconFactory.generic;
    		} else {
                serviceName = ConstantMixin.getIconIndexByCode(this.props.social.psID);
            }
        } else if (this.props.social.gsID) {
            ServiceIcon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.social.gsID, 'generic')];
            serviceName = ConstantMixin.getIconIndexByCode(this.props.social.gsID, 'generic');
        }

        if (this.props.retweet) {
            ServiceIcon = IconFactory.retweet;
        }

        if (this.props.social.icon) {
            avatar = <div className="avatar-bg"><img src={this.props.social.icon} className="avatar-img"/></div>;
		} else if (this.props.connect) {
			avatar = <div className="avatar-bg"><i className="fa fa-plus"></i></div>;
		} else {
			avatar = <div className="avatar-bg"><i className="fa fa-user"></i></div>;
            defaultIcon = true;
		}

        if (this.props.compact) {
            serviceIcon = (
                <ServiceIcon inactive={this.props.unselected} white={true} bare={true}/>
            );
            if (this.props.compactSmall) {
                animatedClass += ' small';
            }
            if (this.props.showCompactName) {
                compactName = this.props.social.name;
            }
            if (this.props.inactive) {
                animatedClass += ' inactive';
            }
            if (this.props.dashed) {
                animatedClass += ' dashed';
            }
            if (!defaultIcon) {
                avatarBlock = (
                    <div className={avatarClass}>
                        {avatar}
                    </div>
                );
            }
            return (
                <div className={animatedWrapperClass} alt={compactName} title={compactName}>
                    <div className={[animatedClass, serviceName, this.props.wrapperClass].join(' ')}>
                        <div className="service-icon">
                            {serviceIcon}
                        </div>
                        {avatarBlock}
                    </div>
                </div>
            );
        }

        if (this.props.type === 'button') {
            avatarClass += ' button';
        }

        if (this.props.large) {
            avatarClass += ' large outlined ' + serviceName;
        }

        // if (this.props.context === 'queue' || this.props.context === "post-modal") {
        //     avatarClass += ' outlined ' + serviceName;
        // }

        if (!this.props.connect) {
            serviceIcon = (
				<ServiceIcon inactive={this.props.unselected} white={true} />
			);
        }

        if (this.props.dashed) {
            avatarClass += ' dashed';
        }

        let alt = this.props.social.name;
        if (this.props.hideAlt) {
            alt = '';
        }

        let wrapperClass = this.props.wrapperClass ? this.props.wrapperClass : '';

        let serviceIconBlock = null;
        if (this.props.hideServiceIcon === undefined || this.props.hideServiceIcon === false) {
            serviceIconBlock = (
                <div className="service-icon">
                    {serviceIcon}
                </div>
            );
        }

        return (
            <div className={"avatar-group " + wrapperClass} alt={alt} title={alt}>
                <div className={avatarClass}>
                    {avatar}
                </div>
                {serviceIconBlock}
            </div>
        );
    }

};

export default SocialAvatar;
